import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';
import { config } from '../../../../config';

interface GuestUser {
  parent_id: string;
  created_by_id: string;
  email: string;
  contact: {
    first_name: string;
    last_name: string;
  };
}

interface GuestUserResponse {
  data: GuestUser;
}

@Injectable()
export class GuestUserService {
  endpoint: string = `${config.apiLocation}/v1/guestusers`;

  constructor(private http: HttpClient) {}

  create(guestUser: RecursivePartial<GuestUser>): Observable<GuestUser> {
    return this.http
      .post<GuestUserResponse>(this.endpoint, guestUser)
      .map(res => res.data);
  }

  update(id: string, guestUser: RecursivePartial<GuestUser>): Observable<GuestUser> {
    return this.http
      .patch<GuestUserResponse>(`${this.endpoint}/${id}`, guestUser)
      .map(res => res.data);
  }

  delete(id: string, guestUser: RecursivePartial<GuestUser>): Observable<void> {
    return this.http
      .request<void>('delete', `${this.endpoint}/${id}`, { body: guestUser });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/users/guest-user.service.ts